module.exports = __webpack_public_path__ + "img/Matschweg.46c7bf8b.jpg";